import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {objectToFormData} from 'object-to-formdata';


@Injectable({
  providedIn: 'root'
})
export class MailContactService {

  data: any = null;
  baseApiUrl: string = environment.api.baseUrl;

  constructor(private http: HttpClient) {
  }

  public send(mailContact: any): Promise<any> {
    return this.http.post(this.baseApiUrl + 'mailing/send', objectToFormData(mailContact)).toPromise().then(
      (data) => {
        return data;
      },
      (data) => {
        if (data.status == 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      }
    );
  }
}
